import { CustomerCleanupConfigurationInfoView } from "@app/shared/models/administration/cleanup/CustomerCleanupConfigurationInfoView";
import { SingleCleanupConfigurationInfoView } from "@app/shared/models/administration/cleanup/SingleCleanupConfigurationInfoView";
import { GlobalCleanupConfigurationInfoView } from "@app/shared/models/administration/cleanup/GlobalCleanupConfigurationInfoView";

export class CleanupInfoView {
    public globalCleanupConfigurationInfo: GlobalCleanupConfigurationInfoView;
    public singleCleanupConfigurationInfo: SingleCleanupConfigurationInfoView;
    public customerCleanupConfigurations: Array<CustomerCleanupConfigurationInfoView>;
}
